"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterCheckbox = void 0;
const react_1 = __importDefault(require("react"));
const emoji_1 = require("../../../ui/_private/emoji");
const core_1 = require("@apitable/core");
const styled_1 = require("./styled");
const FilterCheckbox = props => {
    const { value, onChange, field } = props;
    return (react_1.default.createElement(styled_1.FilterInputWrap, null,
        react_1.default.createElement("div", { style: {
                width: '16px',
                height: '16px',
                cursor: 'pointer',
                opacity: value ? '1' : '0.2'
            }, onClick: () => {
                onChange(!value);
            } },
            react_1.default.createElement(emoji_1.Emoji, { emoji: field.property.icon, size: core_1.ConfigConstant.CELL_EMOJI_SIZE }))));
};
exports.FilterCheckbox = FilterCheckbox;
